export default {"src":"/gallery/_next/static/media/torus.3d708e2d.svg","height":36,"width":34,"blurWidth":0,"blurHeight":0};